import { configureStore } from "@reduxjs/toolkit";
import ssoSlice from "../ssoSlicer/ssoSlice";

const store = configureStore({
    reducer: ssoSlice
})


export default store